import React from "react";
import { ICompany } from "../../models/ICompany";
import { SemanticICONS } from "semantic-ui-react/dist/commonjs/generic";
import { Icon } from "semantic-ui-react";
import { RenderCompany } from "./RenderCompany";

interface CompanyNameProps {
    as?: any;
    company: ICompany;
    icon?: SemanticICONS | boolean;
    className?: string
};

const CompanyName: React.FC<CompanyNameProps> = ({
    as: CustomWrapper,
    company,
    icon,
    ...otherProps
}) => {
    const Wrapper = CustomWrapper || "span"
    return (
        <Wrapper {...otherProps}>
            {typeof icon === "string" ? (
                <Icon name={icon} />
            ) : icon ? (
                <Icon name="building" />
            ) : null
            }

            {company.name}

        </Wrapper>
    );
};

export const CompanyNameById: React.FC<Omit<CompanyNameProps, "company"> & { companyId: ICompany["id"] }> = ({ companyId, ...props }) => {
    return (
        <RenderCompany
            companyId={companyId}
            render={({ company }) => {
                if (!company) {
                    return <div className="CompanyNameById-loading" />
                }
                return (
                    <CompanyName {...props} company={company} />
                )
            }}
        />
    )
};

export default CompanyName;
